import LazySeoFooter from '@nrdy-marketing-engine/footer/src/lazy-seo-footer';
import SeoFooter from '@nrdy-marketing-engine/footer/src/seo-footer';
import clsx from 'clsx';
import { LayoutProps } from '../@types/schema';
import Layout from './layout';

const SeoLayout = ({ theme, mainClassName, children, lazy, ...props }: LayoutProps) => {
  const mainClasses = clsx('flex-1', mainClassName);

  return (
    <Layout {...props} renderFooter={lazy ? LazySeoFooter : SeoFooter}>
      <main className={mainClasses}>{children}</main>
    </Layout>
  );
};

export default SeoLayout;
